import { getCanonicalRoles } from "../../../lib/auth";

/**
 * Reads the signed-in user's canonical roles (from sessionDB / JWT via
 * lib/auth) and reports whether HR is among them. `loading` is always false
 * so callers never render a blank page; the shape is kept future-proof for
 * when a role-resolving API is introduced.
 */
export function useIsHR() {
  const roles = getCanonicalRoles();
  const isHR = roles.some((r) => r === "hr" || r.startsWith("hr "));
  return { isHR, loading: false };
}
